__turbopack_context__.v({
  "image": "SearchNoResult-module-scss-module__NQdL9W__image",
  "wrapper": "SearchNoResult-module-scss-module__NQdL9W__wrapper",
});
